import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SummarySale = () => {
  const apiUrl = process.env.REACT_APP_SERVER_API;
  const getOutlet = JSON.parse(localStorage.getItem("SelectedOutlet")) || {};
  const trOutletId = getOutlet?.outlate_id;
  const summaryDate = localStorage.getItem("SummaryDate");
  const openingCash = Number(localStorage.getItem("OpeningCash")) || 0;
  const openingOfficeCash =
    Number(localStorage.getItem("OpeningOfficeCash")) || 0;
  const [transactionData, setTransactionData] = useState([]);
  const [expData, setExpData] = useState([]);

  console.log("expData", expData);

  const [closingCash, setClosingCash] = useState("");
  const navigate = useNavigate();
  const [allowDayEnd, setAllowDayEnd] = useState("No");
  const [cashsummarydata, setcashsummarydata] = useState([]);
  const [gstVatData, setGstVatData] = useState({
    GST: "",
    VAT: "",
  });

  console.log(cashsummarydata);

  const fetchOpeningData = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}cash-summary?outletId=${trOutletId}`
      );
      const data = response.data.data;

      localStorage.setItem("OpeningCash", data.OpeningCash || 0);
      localStorage.setItem("OpeningOfficeCash", data.OfficeOpeningCash || 0);
      setcashsummarydata(response.data.data);
      if (data.SummaryDate) {
        const dateObj = new Date(data.SummaryDate);
        const formattedDate = `${String(dateObj.getDate()).padStart(
          2,
          "0"
        )}/${String(dateObj.getMonth() + 1).padStart(
          2,
          "0"
        )}/${dateObj.getFullYear()}`;
        localStorage.setItem("SummaryDate", formattedDate);
      }
    } catch (error) {
      console.error("Fetch Error", error);
    }
  };

  useEffect(() => {
    if (cashsummarydata && Object.keys(cashsummarydata).length > 0) {
      setGstVatData({
        GST:
          cashsummarydata.GST != null
            ? Number(cashsummarydata.GST).toFixed(2)
            : "",
        VAT:
          cashsummarydata.VAT != null
            ? Number(cashsummarydata.VAT).toFixed(2)
            : "",
      });
    }
  }, [cashsummarydata]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (/^\d*\.?\d{0,2}$/.test(value) || value === "") {
      setGstVatData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const CashSummaryGSTANDVATUpdate = async () => {
    const rawDate = localStorage.getItem("SummaryDate"); // "02/06/2025"
    const [day, month, year] = rawDate.split("/");
    const formattedDate = new Date(`${year}-${month}-${day}T00:00:00.000Z`);
    try {
      const payload = {
        GST: parseFloat(gstVatData.GST) || 0,
        VAT: parseFloat(gstVatData.VAT) || 0,
        Outlet_Id: trOutletId,
        SummaryDate: formattedDate.toISOString(),
      };

      await axios.put(`${apiUrl}updateGstVat`, payload);
      console.log("GST and VAT updated successfully!");
    } catch (error) {
      console.error("Update failed:", error);
      console.log("Failed to update GST and VAT.");
    }
  };

  const fetchAccountHeads = async () => {
    try {
      const response = await axios.get(`${apiUrl}Accounts`, {
        params: { Outlet_Id: trOutletId },
      });
      setTransactionData([...response.data.map((item) => ({ ...item }))]);
      setExpData([...response.data.map((item) => ({ ...item }))]);
    } catch (error) {
      console.error("Account Heads Get Error", error);
    }
  };

  useEffect(() => {
    fetchOpeningData();
    fetchAccountHeads();
  }, [trOutletId]);

  const handleAmtBankChange = (trId, value) => {
    // Allow only numbers and optional one decimal point
    if (/^\d*\.?\d{0,2}$/.test(value) || value === "") {
      const updatedData = transactionData.map((item) =>
        item.Tr_Id === trId ? { ...item, AmtBank: value } : item
      );
      setTransactionData(updatedData);
      setAllowDayEnd("No");
    }
  };

  const updateCrDrToDR = () => {
    const updatedData = transactionData.map((item) => {
      if (
        item.MainAc_id === 2 &&
        item.SubAc_id === 99 &&
        item.SubsubAc_id === 2
      ) {
        return { ...item, CrDr: "DR" };
      }
      return item;
    });
    setTransactionData(updatedData);
  };

  const handleSaveAll = async () => {
    CashSummaryGSTANDVATUpdate();
    fetchOpeningData();

    // Step 1: Calculate Cash Sale
    const cashSaleValue = (
      transactionData
        .filter(
          (item) =>
            (item.MainAc_id === 3 &&
              item.SubAc_id === 1 &&
              item.SubsubAc_id === 1) ||
            (item.MainAc_id === 3 &&
              item.SubAc_id === 1 &&
              item.SubsubAc_id === 2)
        )
        .reduce((sum, item) => sum + parseFloat(item.AmtCash || 0), 0) -
      transactionData
        .filter((item) => item.MainAc_id === 2 && item.SubAc_id === 2)
        .reduce((sum, item) => sum + parseFloat(item.AmtBank || 0), 0)
    ).toFixed(2);

    let updatedTransactionData = [...transactionData];
    const csIndex = updatedTransactionData.findIndex(
      (item) =>
        item.MainAc_id === 2 && item.SubAc_id === 3 && item.SubsubAc_id === 1
    );

    const cashSaleEntry = {
      MainAc_id: 2,
      SubAc_id: 3,
      SubsubAc_id: 1,
      AmtCash: parseFloat(cashSaleValue),
      CrDr: "CR",
      Outlet_Id: getOutlet?.outlate_id ?? 0,
      Narration: "Cash Sale",
    };

    if (csIndex !== -1) {
      updatedTransactionData[csIndex] = {
        ...updatedTransactionData[csIndex],
        ...cashSaleEntry,
      };
    } else {
      updatedTransactionData.push(cashSaleEntry);
    }

    // Step 3: Filter relevant records
    const filteredData = updatedTransactionData.filter(
      (item) =>
        (item.MainAc_id === 2 && item.SubAc_id === 2) ||
        (item.MainAc_id === 3 &&
          item.SubAc_id === 1 &&
          item.SubsubAc_id === 1) ||
        (item.MainAc_id === 3 &&
          item.SubAc_id === 1 &&
          item.SubsubAc_id === 2) ||
        (item.MainAc_id === 2 &&
          item.SubAc_id === 99 &&
          item.SubsubAc_id === 2 &&
          item.CrDr === "DR") ||
        (item.MainAc_id === 2 &&
          item.SubAc_id === 99 &&
          item.SubsubAc_id === 2 &&
          item.CrDr === "CR") ||
        (item.MainAc_id === 2 &&
          item.SubAc_id === 99 &&
          item.SubsubAc_id === 3) ||
        (item.MainAc_id === 4 &&
          item.SubAc_id === 99 &&
          item.SubsubAc_id === 1) ||
        (item.MainAc_id === 2 && item.SubAc_id === 3 && item.SubsubAc_id === 1)
    );

    // Step 4: Prepare payload with Tr_date
    const payload = filteredData.map(({ _id, ...rest }) => ({
      ...rest,
      Tr_date: summaryDate,
    }));

    try {
      await axios.put(`${apiUrl}SaleSummary`, payload);
      alert("All transactions saved successfully!");
    } catch (error) {
      console.error("Save Error", error);
      alert("Error saving transactions.");
    }
  };

  const todaysTotalCash = (
    parseFloat(openingCash || 0) +
    transactionData
      .filter(
        (item) =>
          item.MainAc_id === 2 &&
          item.SubAc_id === 99 &&
          item.SubsubAc_id === 2 &&
          item.CrDr === "DR"
      )
      .reduce((sum, item) => sum + parseFloat(item.AmtCash || 0), 0) +
    transactionData
      .filter(
        (item) =>
          item.MainAc_id === 3 &&
          item.SubAc_id === 1 &&
          (item.SubsubAc_id === 1 || item.SubsubAc_id === 2)
      )
      .reduce((sum, item) => sum + parseFloat(item.AmtCash || 0), 0) -
    transactionData
      .filter((item) => item.MainAc_id === 2 && item.SubAc_id === 2)
      .reduce((sum, item) => sum + parseFloat(item.AmtBank || 0), 0)
  ).toFixed(2);

  const LessCashExp = expData
    .filter(
      (item) => item.MainAc_id == 4 && item.SubAc_id >= 1 && item.SubAc_id < 99
    )
    .reduce((sum, item) => {
      // const bank = parseFloat(item.AmtBank || 0);
      const cash = parseFloat(item.AmtCash || 0);
      return sum + cash;
    }, 0)
    .toFixed(2);

  const BankExp = expData
    .filter(
      (item) => item.MainAc_id == 4 && item.SubAc_id >= 1 && item.SubAc_id < 99
    )
    .reduce((sum, item) => {
      const bank = parseFloat(item.AmtBank || 0);
      // const cash = parseFloat(item.AmtCash || 0);
      return sum + bank;
    }, 0)
    .toFixed(2);

  const crOfficeCash = transactionData
    .filter(
      (item) =>
        item.MainAc_id === 2 &&
        item.SubAc_id === 99 &&
        item.SubsubAc_id === 2 &&
        item.CrDr === "CR"
    )
    .reduce((sum, item) => sum + parseFloat(item.AmtCash || 0), 0);

  const lessGstVatCash = transactionData
    .filter(
      (item) =>
        item.MainAc_id === 2 && item.SubAc_id === 99 && item.SubsubAc_id === 3
    )
    .reduce((sum, item) => sum + parseFloat(item.AmtCash || 0), 0);

  const BalanceCashtotal = (
    parseFloat(todaysTotalCash || 0) -
    parseFloat(LessCashExp || 0) -
    crOfficeCash -
    lessGstVatCash
  ).toFixed(2);

  // Helper function to convert date format
  function convertToISODate(dateStr) {
    if (!dateStr) return null;
    try {
      const [day, month, year] = dateStr.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    } catch (error) {
      console.error("Date conversion error:", error);
      return null;
    }
  }

  const OfficeCloseCash =
    parseFloat(openingOfficeCash || 0) +
    transactionData
      .filter(
        (item) =>
          item.MainAc_id === 2 &&
          item.SubAc_id === 99 &&
          item.SubsubAc_id === 2 &&
          item.CrDr === "CR"
      )
      .reduce((sum, item) => sum + parseFloat(item.AmtCash || 0), 0) +
    transactionData
      .filter(
        (item) =>
          item.MainAc_id === 2 &&
          item.SubAc_id === 99 &&
          item.SubsubAc_id === 2 &&
          item.CrDr === "DR"
      )
      .reduce((sum, item) => sum + parseFloat(item.AmtBank || 0), 0);

  const formattedDate = convertToISODate(summaryDate);

  // Update cash summary for day end
  const updateCashSummary = async (event) => {
    event.preventDefault();

    const closingData = {
      Outlet_Id: trOutletId,
      SummaryDate: formattedDate,
      ClosingCash: BalanceCashtotal,
      OfficeClosingCash: OfficeCloseCash,
      OutletClosingCash: closingCash,
    };

    try {
      const response = await axios.put(`${apiUrl}cash-summary`, closingData);

      if (response.data?.message === "Cash Summary Updated") {
        alert("Closing Cash Posted Successfully!");
        navigate("/AccsDashboard/Accounts");
      } else {
        alert("Unexpected response. Please check your data.");
      }
    } catch (error) {
      console.error("Closing Cash Posting Error", error);
      alert("Error posting closing cash. Please try again.");
    }
  };

  // Day End Buttoin Validation Total Sale > 0 day End Allow
  const isValidCashAvailable = transactionData.some(
    (item) =>
      item.MainAc_id === 3 &&
      item.SubAc_id === 1 &&
      item.SubsubAc_id === 1 &&
      parseFloat(item.AmtCash) > 0
  );

  return (
    <div className="container-fluid border p-0">
      <div className="row m-0">
        <div className="col-md-12 p-3">
          <div className="row">
            <div className="col-md-4 border">
              <h6 className="text-center">Sale Summary for {summaryDate}</h6>

              {transactionData
                .filter(
                  (item) =>
                    item.MainAc_id === 3 &&
                    item.SubAc_id === 1 &&
                    item.SubsubAc_id === 1
                )
                .map((item) => (
                  <div
                    key={item._id}
                    className="d-flex justify-content-end mt-2"
                  >
                    <div className="mb-1 d-flex align-items-center">
                      <label className="form-label me-2 mb-0">
                        Total Sale <span className="ms-1 me-1">→</span>
                      </label>
                      <input
                        type="text"
                        className="form-control text-end"
                        style={{ width: "125px", height: "30px" }}
                        placeholder="Cash"
                        value={item.AmtCash ?? ""}
                        onChange={(e) => {
                          const inputValue = e.target.value;

                          if (
                            /^\d*\.?\d{0,2}$/.test(inputValue) ||
                            inputValue === ""
                          ) {
                            const updatedData = [...transactionData];
                            const idx = transactionData.findIndex(
                              (i) => i._id === item._id
                            );
                            if (idx !== -1) {
                              updatedData[idx].AmtCash = inputValue;
                              setTransactionData(updatedData);
                              setClosingCash(0);
                            }
                          }
                        }}
                        onBlur={() => {
                          const idx = transactionData.findIndex((i) => i._id === item._id);
                          if (idx !== -1) {
                            let value = parseFloat(transactionData[idx].AmtCash);
                            if (isNaN(value)) {
                              value = 0;
                            }
                            const updatedData = [...transactionData];
                            updatedData[idx].AmtCash = value.toFixed(2);
                            setTransactionData(updatedData);
                          }
                        }}                        
                      />
                    </div>
                  </div>
                ))}

              {transactionData
                .filter(
                  (item) =>
                    item.SubAc_id === 1 &&
                    item.MainAc_id === 3 &&
                    item.SubsubAc_id === 2
                )
                .map((item) => (
                  <div
                    key={item._id}
                    className="d-flex justify-content-end mt-2"
                  >
                    <div className="mb-1 d-flex align-items-center">
                      <label className="form-label me-2 mb-0">
                        External Sale <span className="ms-1 me-1">→</span>
                      </label>
                      <input
                        type="text"
                        className="form-control text-end"
                        style={{ width: "125px", height: "30px" }}
                        placeholder="Cash"
                        value={item.AmtCash ?? ""}
                        onChange={(e) => {
                          const inputValue = e.target.value;

                          if (
                            /^\d*\.?\d{0,2}$/.test(inputValue) ||
                            inputValue === ""
                          ) {
                            const updatedData = [...transactionData];
                            const idx = transactionData.findIndex(
                              (i) => i._id === item._id
                            );
                            if (idx !== -1) {
                              updatedData[idx].AmtCash = inputValue;
                              setTransactionData(updatedData);
                            }
                          }
                        }}
                        onBlur={() => {
                          const idx = transactionData.findIndex((i) => i._id === item._id);
                          if (idx !== -1) {
                            let value = parseFloat(transactionData[idx].AmtCash);
                            if (isNaN(value)) {
                              value = 0;
                            }
                            const updatedData = [...transactionData];
                            updatedData[idx].AmtCash = value.toFixed(2);
                            setTransactionData(updatedData);
                          }
                        }}
                        
                      />
                    </div>
                  </div>
                ))}

              <table className="table">
                <thead>
                  <tr>
                    <th className="border" style={{ width: "280px" }}>
                      Accounts
                    </th>
                    <th className="border">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {transactionData
                    .filter(
                      (item) => item.MainAc_id === 2 && item.SubAc_id === 2
                    )
                    .map((item) => (
                      <tr key={item.Tr_Id}>
                        <td className="border p-1">By {item.Narration}</td>
                        <td className="border p-1">
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            value={item.AmtBank ?? ""}
                            onChange={(e) =>
                              handleAmtBankChange(item.Tr_Id, e.target.value)
                            }
                            onBlur={() => {
                              let value = parseFloat(item.AmtBank);
                              if (isNaN(value)) {
                                value = 0;
                              }
                              const updatedData = transactionData.map((row) =>
                                row.Tr_Id === item.Tr_Id
                                  ? { ...row, AmtBank: value.toFixed(2) }
                                  : row
                              );
                              setTransactionData(updatedData);
                            }}
                            
                            style={{ height: "30px" }}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>

              <div className="d-flex justify-content-end mb-1">
                <label className="me-4">
                  Total Sale By Credit <span className="ms-1 me-1">→</span>
                </label>
                <input
                  type="text"
                  className="form-control p-1 text-end"
                  name="ttlBank"
                  value={transactionData
                    .filter(
                      (item) => item.MainAc_id === 2 && item.SubAc_id === 2
                    )
                    .reduce(
                      (sum, item) => sum + parseFloat(item.AmtBank || 0),
                      0
                    )
                    .toFixed(2)}
                  readOnly
                  style={{ width: "27%", backgroundColor: "#f0f0f0" }}
                  placeholder="0.00"
                />
              </div>

              <div className="d-flex justify-content-end mb-1">
                <label className="me-4">
                  Cash Sale <span className="ms-1 me-1">→</span>
                </label>
                <input
                  type="text"
                  className="form-control p-1 text-end"
                  name="ttlCombined"
                  value={(
                    transactionData
                      .filter(
                        (item) =>
                          (item.MainAc_id === 3 &&
                            item.SubAc_id === 1 &&
                            item.SubsubAc_id === 1) ||
                          (item.MainAc_id === 3 &&
                            item.SubAc_id === 1 &&
                            item.SubsubAc_id === 2)
                      )
                      .reduce(
                        (sum, item) => sum + parseFloat(item.AmtCash || 0),
                        0
                      ) -
                    transactionData
                      .filter(
                        (item) => item.MainAc_id === 2 && item.SubAc_id === 2
                      )
                      .reduce(
                        (sum, item) => sum + parseFloat(item.AmtBank || 0),
                        0
                      )
                  ).toFixed(2)}
                  readOnly
                  style={{ width: "27%", backgroundColor: "#f0f0f0" }}
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="col-md-3  p-0  justify-content-center">
              <div className="border">
                <h6 className="text-center">Cash Calculation</h6>

                <div className="d-flex justify-content-end mb-1">
                  <label className="me-4">
                    Cash Sale <span className="ms-1 me-1">→</span>
                  </label>
                  <input
                    type="text"
                    className="form-control p-1 text-end"
                    name="ttlCombined"
                    value={(
                      transactionData
                        .filter(
                          (item) =>
                            (item.MainAc_id === 3 &&
                              item.SubAc_id === 1 &&
                              item.SubsubAc_id === 1) ||
                            (item.MainAc_id === 3 &&
                              item.SubAc_id === 1 &&
                              item.SubsubAc_id === 2)
                        )
                        .reduce(
                          (sum, item) => sum + parseFloat(item.AmtCash || 0),
                          0
                        ) -
                      transactionData
                        .filter(
                          (item) => item.MainAc_id === 2 && item.SubAc_id === 2
                        )
                        .reduce(
                          (sum, item) => sum + parseFloat(item.AmtBank || 0),
                          0
                        )
                    ).toFixed(2)}
                    readOnly
                    style={{ width: "110px", height: "30px" }}
                    placeholder="0.00"
                  />
                </div>
                <div className="d-flex justify-content-end mb-1">
                  <label className="me-4">
                    Add Opening Cash <span className="ms-1 me-1">→</span>
                  </label>
                  <input
                    type="text"
                    className="form-control p-1 text-end"
                    name="ttlCombined"
                    value={openingCash}
                    readOnly
                    style={{ width: "110px", height: "30px" }}
                    placeholder="0.00"
                  />
                </div>
                {transactionData
                  .filter(
                    (item) =>
                      item.MainAc_id === 2 &&
                      item.SubAc_id === 99 &&
                      item.SubsubAc_id === 2 &&
                      item.CrDr == "DR"
                  )
                  .map((item) => (
                    <div
                      key={item._id}
                      className="d-flex justify-content-end mt-2"
                    >
                      <div className="mb-1 d-flex justify-content-end">
                        <label className="form-label me-4 mb-0">
                          Add Office Cash <span className="ms-1 me-1">→</span>
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          style={{ width: "110px", height: "30px" }}
                          placeholder="Amount"
                          value={item.AmtCash ?? ""}
                          onChange={(e) => {
                            const inputValue = e.target.value;

                            // Allow only digits and at most one decimal with up to 2 digits after
                            if (
                              /^\d*\.?\d{0,2}$/.test(inputValue) ||
                              inputValue === ""
                            ) {
                              const updatedData = [...transactionData];
                              const idx = transactionData.findIndex(
                                (i) => i._id === item._id
                              );
                              if (idx !== -1) {
                                updatedData[idx].AmtCash = inputValue;
                                updatedData[idx].CrDr = "DR"; // Force CrDr = DR
                                setTransactionData(updatedData);
                              }
                            }
                          }}
                          onBlur={() => {
                            const idx = transactionData.findIndex((i) => i._id === item._id);
                            if (idx !== -1) {
                              let value = parseFloat(transactionData[idx].AmtCash);
                              if (isNaN(value)) {
                                value = 0;
                              }
                              const updatedData = [...transactionData];
                              updatedData[idx].AmtCash = value.toFixed(2);
                              setTransactionData(updatedData);
                            }
                          }}
                          
                        />
                      </div>
                    </div>
                  ))}

                <div className="d-flex justify-content-end mb-1">
                  <label className="me-4">
                    Todays Total Cash <span className="ms-1 me-1">→</span>
                  </label>
                  <input
                    type="text"
                    className="form-control p-1 text-end"
                    name="todaysCash"
                    value={todaysTotalCash}
                    readOnly
                    style={{ width: "110px", height: "30px" }}
                    placeholder="0.00"
                  />
                </div>
                <div className="d-flex justify-content-end mb-1">
                  <label className="me-4">
                    Less Cash Expenses <span className="ms-1 me-1">→</span>
                  </label>
                  <input
                    type="text"
                    className="form-control p-1 text-end"
                    name="todaysCash"
                    value={LessCashExp}
                    readOnly
                    style={{ width: "110px", height: "30px" }}
                    placeholder="0.00"
                  />
                </div>

                {transactionData
                  .filter(
                    (item) =>
                      item.MainAc_id == 2 &&
                      item.SubAc_id == 99 &&
                      item.SubsubAc_id == 2 &&
                      item.CrDr == "CR"
                  )
                  .map((item) => (
                    <div
                      key={item._id}
                      className="d-flex justify-content-end mt-2"
                    >
                      <div className="mb-1 d-flex justify-content-end">
                        <label className="form-label me-4 mb-0">
                          Less Office Cash <span className="ms-1 me-1">→</span>
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          style={{ width: "110px", height: "30px" }}
                          placeholder="Cash"
                          value={item.AmtCash ?? ""}
                          onChange={(e) => {
                            const inputValue = e.target.value;

                            if (
                              /^\d*\.?\d{0,2}$/.test(inputValue) ||
                              inputValue === ""
                            ) {
                              const updatedData = [...transactionData];
                              const idx = transactionData.findIndex(
                                (i) => i._id === item._id
                              );
                              if (idx !== -1) {
                                updatedData[idx].AmtCash = inputValue;
                                setTransactionData(updatedData);
                              }
                            }
                          }}
                          onBlur={() => {
                            const idx = transactionData.findIndex((i) => i._id === item._id);
                            if (idx !== -1) {
                              let value = parseFloat(transactionData[idx].AmtCash);
                              if (isNaN(value)) {
                                value = 0;
                              }
                              const updatedData = [...transactionData];
                              updatedData[idx].AmtCash = value.toFixed(2);
                              setTransactionData(updatedData);
                            }
                          }}
                          
                        />
                      </div>
                    </div>
                  ))}

                {transactionData
                  .filter(
                    (item) =>
                      item.MainAc_id === 2 &&
                      item.SubAc_id === 99 &&
                      item.SubsubAc_id === 3
                  )
                  .map((item) => (
                    <div
                      key={item._id}
                      className="d-flex justify-content-end mt-2"
                    >
                      <div className="mb-1 d-flex justify-content-end">
                        <label className="form-label me-4 mb-0">
                          Less Cash to HO <span className="ms-1 me-1">→</span>
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          style={{ width: "110px", height: "30px" }}
                          placeholder="Cash"
                          value={item.AmtCash ?? ""}
                          onChange={(e) => {
                            const inputValue = e.target.value;

                            if (
                              /^\d*\.?\d{0,2}$/.test(inputValue) ||
                              inputValue === ""
                            ) {
                              const updatedData = [...transactionData];
                              const idx = transactionData.findIndex(
                                (i) => i._id === item._id
                              );
                              if (idx !== -1) {
                                updatedData[idx].AmtCash = inputValue;
                                setTransactionData(updatedData);
                              }
                            }
                          }}
                          onBlur={() => {
                            const idx = transactionData.findIndex((i) => i._id === item._id);
                            if (idx !== -1) {
                              let value = parseFloat(transactionData[idx].AmtCash);
                              if (isNaN(value)) {
                                value = 0;
                              }
                              const updatedData = [...transactionData];
                              updatedData[idx].AmtCash = value.toFixed(2);
                              setTransactionData(updatedData);
                            }
                          }}
                          
                        />
                      </div>
                    </div>
                  ))}

                <div className="d-flex justify-content-end mb-1">
                  <label className="me-4">
                    Balance Cash <span className="ms-1 me-1">→</span>
                  </label>
                  <input
                    type="text"
                    className="form-control p-1 text-end"
                    name="BalanceCashtotal"
                    value={BalanceCashtotal}
                    readOnly
                    style={{ width: "110px", height: "30px" }}
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div className="border d-flex justify-content-end mt-2 gap-2 p-2">
                <input
                  type="text"
                  name="GST"
                  className="form-control w-50 text-end"
                  placeholder="Enter GST"
                  value={gstVatData.GST}
                  onChange={handleInputChange}
                />
                <input
                  type="text"
                  name="VAT"
                  className="form-control w-50 text-end"
                  placeholder="Enter VAT"
                  value={gstVatData.VAT}
                  onChange={handleInputChange}
                />
              </div>

              <div className="border mt-2">
                {transactionData
                  .filter(
                    (item) =>
                      item.MainAc_id === 4 &&
                      item.SubAc_id === 99 &&
                      item.SubsubAc_id === 1
                  )
                  .map((item) => (
                    <div
                      key={item._id}
                      className="d-flex justify-content-end mt-2"
                    >
                      <div className="mb-1 d-flex justify-content-end">
                        <label className="form-label me-4 mb-0">
                          Pending Bills Total{" "}
                          <span className="ms-1 me-1">→</span>
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          style={{ width: "110px", height: "30px" }}
                          placeholder="Cash"
                          value={item.AmtCash ?? ""}
                          onChange={(e) => {
                            const inputValue = e.target.value;

                            if (
                              /^\d*\.?\d{0,2}$/.test(inputValue) ||
                              inputValue === ""
                            ) {
                              const updatedData = [...transactionData];
                              const idx = transactionData.findIndex(
                                (i) => i._id === item._id
                              );
                              if (idx !== -1) {
                                updatedData[idx].AmtCash = inputValue;
                                setTransactionData(updatedData);
                              }
                            }
                          }}
                          onBlur={() => {
                            const idx = transactionData.findIndex((i) => i._id === item._id);
                            if (idx !== -1) {
                              let value = parseFloat(transactionData[idx].AmtCash);
                              if (isNaN(value)) {
                                value = 0;
                              }
                              const updatedData = [...transactionData];
                              updatedData[idx].AmtCash = value.toFixed(2);
                              setTransactionData(updatedData);
                            }
                          }}
                          
                        />
                      </div>
                    </div>
                  ))}
              </div>

              <div className="border mt-2 p-3">
                <div className="d-flex justify-content-between mb-3">
                  <input
                    type="text"
                    className="form-control p-1 text-end"
                    name="ClosingCash"
                    value={closingCash}
                    onChange={(e) => {
                      const inputValue = e.target.value;

                      if (
                        /^\d*\.?\d{0,2}$/.test(inputValue) ||
                        inputValue === ""
                      ) {
                        setClosingCash(inputValue);
                      }
                    }}
                    onBlur={() => {
                      let value = parseFloat(closingCash);
                      if (isNaN(value)) {
                        value = 0;
                      }
                      setClosingCash(value.toFixed(2));
                    }}
                    
                    style={{ width: "140px", height: "30px" }}
                    placeholder="Enter Closing Cash"
                  />

                  <input
                    type="text"
                    className="form-control p-1 text-end"
                    name="difference"
                    value={(
                      parseFloat(closingCash || 0) -
                      parseFloat(BalanceCashtotal || 0)
                    ).toFixed(2)}
                    style={{ width: "140px", height: "30px" }}
                    placeholder="0.00"
                    readOnly
                  />
                </div>

                {/* Centered buttons */}
                <div className="d-flex justify-content-between mt-2">
                  <button
                    className="btn btn-success "
                    disabled={allowDayEnd == "Yes"}
                    onClick={handleSaveAll}
                  >
                    Submit Summary
                  </button>
                  <button
                    className="btn btn-warning"
                    disabled={
                      allowDayEnd == "No" &&
                      (closingCash == 0 || !isValidCashAvailable || null)
                    }
                    onClick={updateCashSummary}
                  >
                    Day End
                  </button>
                </div>
              </div>
              <div className="d-flex justify-content-center"></div>
            </div>

            <div className="col-md-4 border">
              <h5 className="text-center">Expenses</h5>

              <div style={{ maxHeight: "200px", overflowx: "auto" }}>
                <table className="table tblcss" style={{ marginLeft: "10px" }}>
                  <thead className="align-middle text-center">
                    <tr>
                      <th className="tdcss" style={{ width: "300px" }}>
                        Particulars
                      </th>
                      <th className="tdcss">Cash Rs.</th>
                      <th className="tdcss">Bank Rs.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {expData
                      .filter(
                        (item) =>
                          item.MainAc_id === 4 &&
                          item.SubAc_id >= 1 &&
                          item.SubAc_id < 99
                      )
                      .map((item) => (
                        <tr key={item.Tr_Id}>
                          <td className="tdcss text-start">{item.Narration}</td>
                          <td className="tdcss text-end">
                            {Number(item.AmtCash || 0).toFixed(2)}
                          </td>
                          <td className="tdcss text-end">
                            {Number(item.AmtBank || 0).toFixed(2)}
                          </td>
                        </tr>
                      ))}

                    <tr className="fw-bold">
                      <td className="tdcss">Total</td>
                      <td className="tdcss text-end">{LessCashExp}</td>
                      <td className="tdcss text-end">{BankExp}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummarySale;
